import { Grid, GridColumn, } from '@progress/kendo-react-grid';
import React from 'react';
import { findLinkGroupByTitle } from '../../../helpers';
import sitterService from '../../../services/sitterService';
import Sidebar from '../Sidebar';
import { ActiveCell, AvailabilityCell, ColumnMenu, ManageProvidersCell, } from './KendoComponents';
class ProvidersGrid extends React.Component {
    state = {
        sitters: [],
        result: [],
        loading: true,
        showOnboardingKey: false,
        linkGroup: findLinkGroupByTitle('Providers'),
        dataState: {
            sort: [{ field: 'firstname', dir: 'asc' }],
            filter: {
                logic: 'and',
                filters: [],
            },
            filterOperators: {
                text: [
                    {
                        text: 'grid.filterContainsOperator',
                        operator: 'contains',
                    },
                    { text: 'grid.filterEqOperator', operator: 'eq' },
                ],
            },
            skip: 0,
            take: 50,
            total: 0,
        },
    };
    componentDidMount = () => {
        this.getProviders();
    };
    getProviders = async () => {
        try {
            const { dataState } = this.state;
            const response = await sitterService.list({
                skip: dataState.skip,
                take: dataState.take,
                sort: dataState.sort,
                filter: dataState.filter,
            });
            if (response.status === 200) {
                const { sitters, count } = response.data.data;
                this.setState({
                    result: sitters,
                    dataState: {
                        ...dataState,
                        total: count,
                    },
                    sitters,
                    loading: false,
                });
            }
        }
        catch {
            this.setState({
                loading: false,
            });
        }
    };
    pageChange = (event) => {
        this.setState({
            dataState: {
                ...this.state.dataState,
                skip: event.page.skip,
                take: event.page.take,
            },
        }, () => {
            this.getProviders();
        });
    };
    sortChange = (event) => {
        this.setState({
            dataState: {
                ...this.state.dataState,
                sort: event.sort,
            },
        }, () => {
            this.getProviders();
        });
    };
    filterChange = (event) => {
        this.setState({
            dataState: {
                ...this.state.dataState,
                filter: event.filter,
            },
        }, () => {
            this.getProviders();
        });
    };
    toggleShowOnboardingKey = () => {
        this.setState((prevState) => ({
            ...prevState,
            showOnboardingKey: !prevState.showOnboardingKey,
        }));
    };
    render() {
        const { loading, linkGroup, dataState, result } = this.state;
        if (!!loading) {
            return (React.createElement("main", { className: "admin admin-listing with-sidebar appointments" },
                React.createElement("div", { className: "sidebar-wrapper" },
                    React.createElement(Sidebar, { ...this.props, iconClass: "fas fa-id-card", linkGroup: linkGroup })),
                React.createElement("div", { className: "content" },
                    React.createElement("h4", { className: "section-label" },
                        React.createElement("i", { className: "fas fa-calendar-star" }),
                        "\u00A0Loading Providers..."))));
        }
        return (React.createElement("main", { className: "admin admin-listing with-sidebar appointments" },
            React.createElement("div", { className: "sidebar-wrapper" },
                React.createElement(Sidebar, { ...this.props, iconClass: "fas fa-id-card", linkGroup: linkGroup })),
            React.createElement("div", { className: "content" },
                React.createElement("h4", { className: "section-label" },
                    React.createElement("i", { className: "fas fa-calendar-star" }),
                    "\u00A0Manage Providers"),
                React.createElement("div", { className: "kendo-table" },
                    React.createElement(Grid, { data: result, pageable: true, sortable: true, ...dataState, onPageChange: this.pageChange, onSortChange: this.sortChange, onFilterChange: this.filterChange },
                        React.createElement(GridColumn, { title: "Email", field: "email", columnMenu: ColumnMenu }),
                        React.createElement(GridColumn, { title: "First Name", field: "firstname", columnMenu: ColumnMenu }),
                        React.createElement(GridColumn, { title: "Last Name", field: "lastname", columnMenu: ColumnMenu }),
                        React.createElement(GridColumn, { title: "Phone", field: "phone1", columnMenu: ColumnMenu }),
                        React.createElement(GridColumn, { title: "Status", field: "active", width: 100, columnMenu: ColumnMenu, cell: (props) => React.createElement(ActiveCell, { ...props, ...this.props }) }),
                        React.createElement(GridColumn, { title: "Available Slots", field: "availability_count", width: 140, columnMenu: ColumnMenu, cell: (props) => (React.createElement(AvailabilityCell, { ...props, ...this.props })) }),
                        React.createElement(GridColumn, { title: "ID", field: "id", width: 60, columnMenu: ColumnMenu }),
                        React.createElement(GridColumn, { title: " ", field: "piid", width: 100, cell: (props) => (React.createElement(ManageProvidersCell, { ...props, ...this.props })) }))))));
    }
}
export default ProvidersGrid;
